// Ver, imprimir y descargar un DTE emitido (pedido de Rodrigo, 2026-10-26: «las que mandan son los
// DTE»). Un solo lugar para la lista de facturas y boletas, la ficha del documento, la nota y la ODD.
import { guardarArchivo, pedirArchivo } from '../api/cliente';
import { imprimirPdf } from '../comun/imprimirPdf';

export const NOMBRE_DTE: Record<number, string> = {
  33: 'Factura',
  34: 'Factura exenta',
  39: 'Boleta',
  41: 'Boleta exenta',
  52: 'Guía de despacho',
  56: 'Nota de débito',
  61: 'Nota de crédito',
};
export const nombreDte = (t: number | null | undefined) =>
  t ? (NOMBRE_DTE[t] ?? `DTE ${t}`) : 'Documento';
/** «Factura N° 4978» (o «Boleta (sin folio)» mientras el motor no lo asigna). */
export const tituloDte = (
  t: number | null | undefined,
  folio: string | number | null | undefined,
) => `${nombreDte(t)} ${folio ? `N° ${folio}` : '(sin folio)'}`;

/**
 * Abre el PDF en otra pestaña. La pestaña se abre al hacer clic, ANTES de pedir el PDF, para que el
 * navegador no la bloquee como ventana emergente. `ambos` = original y, si lo lleva, el cedible.
 */
export function verPdfDte(
  documentoId: string,
  ejemplar: 'original' | 'cedible' | 'ambos' = 'ambos',
): Promise<void> {
  const ventana = window.open('', '_blank');
  return pedirArchivo('GET', `/dte/documentos/${documentoId}/pdf`, { query: { ejemplar } })
    .then((b) => {
      const url = URL.createObjectURL(b);
      if (ventana) ventana.location.href = url;
      else window.open(url, '_blank', 'noopener');
    })
    .catch((e: unknown) => {
      ventana?.close();
      throw e;
    });
}

/** Directo a la impresora: factura con su cedible; boleta en dos originales (como el punto de venta). */
export async function imprimirDte(documentoId: string): Promise<void> {
  imprimirPdf(
    await pedirArchivo('GET', `/dte/documentos/${documentoId}/pdf`, { query: { ejemplar: 'dos' } }),
  );
}

export async function descargarXmlDte(
  documentoId: string,
  tipoDte: number,
  folio: string | number | null,
): Promise<void> {
  const b = await pedirArchivo('GET', `/dte/documentos/${documentoId}/xml`);
  guardarArchivo(b, `DTE${tipoDte}-${folio ?? documentoId.slice(0, 8)}.xml`);
}
